import { useCallback, useRef, useState } from "react";
import { t } from "i18next";
import { useTheme } from "../../stores";
import { ActionMenu } from "../ActionMenu";
import * as UI from "@smartsuite/react-ui/lib";
import * as S from "./styles";
import PlusIcon from "../../../generated/images/Plus";
import { Colors, GrayColors } from "@smartsuite/types";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../stores/hooks";
import { useFlowCanvasMenuDismiss } from "../FlowCanvas/hooks/use-flow-canvas-menu-dismiss";

export const AddActionButton: React.FC<{
  enabled: boolean;
  bigSize: boolean;
  label: string;
  showError: boolean;
  setActiveTrigger?: (isActive?: boolean) => void;
  onClick: (integrationId: string, actionId: string) => void;
  setActiveAction?: (actionHash?: string) => void;
  setActiveSection: (
    item: {
      type: "trigger" | "action" | "looping";
      hash: string;
    } | null,
  ) => void;
}> = observer(
  ({
    enabled,
    bigSize,
    label,
    showError,
    onClick,
    setActiveSection,
    setActiveAction,
    setActiveTrigger,
  }) => {
    const theme = useTheme();
    const btnRef = useRef(null);
    const store = useRootStore();
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    useFlowCanvasMenuDismiss(useCallback(() => setIsMenuOpen(false), []));

    const looping = store.automations.candidate.self.actionGroups.find(
      (action) => action.config.oneofKind === "loop",
    );

    // v1: advanced-logic blocks are mutually exclusive (one per automation) — mirrors Looping; revisit with product question Q6
    const isShowAdvancedLogic =
      !looping && !store.automations.candidate.branches.hasBranches;

    return (
      <>
        <S.Button
          ref={btnRef}
          isEnabled={enabled}
          isActive={isMenuOpen}
          bigSize={bigSize}
          borderColor={theme.primaryColor}
          onClick={() => enabled && setIsMenuOpen((isOpen) => !isOpen)}
        >
          <S.Content isEnabled={enabled}>
            <PlusIcon
              style={{ marginRight: "13px" }}
              fill={enabled ? theme.primaryColor : GrayColors["G-4"]}
            />{" "}
            {label}
          </S.Content>
          <S.WarningIcon>
            {showError && (
              <UI.Tooltip
                placements={["top"]}
                text={t("automation-form.action-not-selected")}
                target={
                  <UI.Icon
                    size={"M"}
                    name={"important-lined"}
                    color={Colors.bRed}
                    width={26}
                    height={26}
                  />
                }
              />
            )}
          </S.WarningIcon>
        </S.Button>
        <ActionMenu
          setActiveTrigger={setActiveTrigger}
          setActiveAction={setActiveAction}
          setActiveSection={setActiveSection}
          showAdvancedLogic={isShowAdvancedLogic}
          menuButtonRef={btnRef}
          isMenuOpen={isMenuOpen}
          setMenuOpen={setIsMenuOpen}
          onActionChange={(integrationId, actionId) =>
            // TODO find another solution for it
            setTimeout(() => onClick(integrationId, actionId), 250)
          }
          showOnboarding
        />
      </>
    );
  },
);
